import * as React from 'react';
import cx from 'classnames';

import { NewTableColumnFilterOption } from '../../../../new-table.types';
import DropdownCore from '@common/containers/fields/Dropdown';

import './dropdown.styles.scss';

export type DropdownProps = {
  moduleName: string;
  value?: NewTableColumnFilterOption['actualValue'];
  className?: string;
  options: Array<NewTableColumnFilterOption>;
  metadata: { property: string };
  onSave: (params: { value: NewTableColumnFilterOption['actualValue']; metadata: { property: string } }) => void;
};

export const Dropdown: React.FC<DropdownProps> = (props) => {
  const { value, className, options, metadata, onSave, moduleName } = props;

  const handleChange = React.useCallback((selectedValue: NewTableColumnFilterOption['actualValue']) => {
    onSave({
      value: selectedValue,
      metadata,
    });
  }, [onSave, metadata]);

  type ProcessedOptions = Array<{ value?: NewTableColumnFilterOption['actualValue']; label: NewTableColumnFilterOption['displayValue'] }>;

  const processedOptions = React.useMemo((): ProcessedOptions => {
    const base: ProcessedOptions = options.map((x) => ({ label: x.displayValue, value: x.actualValue }));
    
    if (options.map((x) => x.displayValue).includes('')) {
      return base;
    }

    base.unshift({ value: undefined, label: '' });

    return base;
  }, [options]);

  const finalValue = value ?? '';

  return (
    <DropdownCore
      fullWidth
      id={`${moduleName}-dropdown--filter`}
      className={cx('TableDropdown', className)}
      selectedValue={finalValue}
      searchable={false}
      options={processedOptions}
      optionsHeight={200}
      onValueChanged={handleChange}
    />
  );
};

Dropdown.defaultProps = {
  options: [],
};